import {TFunction} from 'i18next';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class SleepPdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (entry) => {
      // TODO: hardcoded id. Feature flag missing.
      const sleepEntry = entry.getEntryById('64a75afa1d7f2724935b758e');
      const sleepName = `<b>${sleepEntry?.name ?? 'n/a'}:</b>`;
      const sleepValue = this.getEntryValue(sleepEntry);

      return `${sleepName}\n${sleepValue}`;
    };
  }
}
